<template>
  <div class="fullwidth about narex">
    <editable-item :page="$route.name" item="text" :loaded="editableLoaded" />
    <div>
      <div class="padform" v-show="!code">
        <label for="code">{{ $nippets.myarea.enterCode }}</label>
        <input type="text" placeholder="Enter verification code" v-model="code" name="code" />
      </div>
      <div class="padform">
        <label for="username">{{ $nippets.myarea.email }}</label>
        <input type="text" :placeholder="$nippets.myarea.username" v-model="username" name="username" />
      </div>
      <div class="padform">
        <label for="newPassword">{{ $nippets.myarea.newPass }}</label>
        <input type="password" placeholder="new password" v-model="password" name="newPassword" />
      </div>
      <div class="padform">
        <label for="repeatPassword">{{ $nippets.myarea.repeatPassword }}</label>
        <input type="password" placeholder="repeat password" v-model="repeatPassword" name="repeatPassword" />
      </div>
      <div class="button-panel">
        <small-button v-on:click="handleChangePassword" large>{{ $nippets.changePassword }}</small-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import Auth from '@aws-amplify/auth'
import EditablePage from '@/mixins/EditablePage.js'
import '@/css/my-area.css'

export default {
  mixins: [EditablePage],
  data () {
    return {
      loaded: false,
      code: '',
      repeatPassword: '',
      password: '',
      username: ''
    }
  },
  created () {
    if(this.$route.query.code) {
      this.code = this.$route.query.code
    }
  },
  methods: {
    async handleChangePassword () {
      try {
        await Auth.forgotPasswordSubmit(this.username, this.code, this.password);
        this.$k.messageBox(this.$nippets.changePassword, this.$nippets.changePasswordSuccess)
      }
      catch(err) {
        this.$k.messageBox(this.$nippets.changePassword, err.message)
      }
    }

  }
}
</script>